module.exports = __webpack_public_path__ + "static/img/6.799f44a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/sp/6.png
// module id = NJtp
// module chunks = 0